import styled from 'styled-components';

import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';

export const Container = styled(Flex)`
  flex-wrap: wrap;
`;

export const Wrapper = styled.div`
  border: 1px solid #ebebeb;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
`;

export const SocialIcon = styled(Icon)`
  width: 1.25rem;
  height: 1.25rem;
`;
